import { render } from "./CardOrder.vue?vue&type=template&id=28f21c1c"
import script from "./CardOrder.vue?vue&type=script&lang=js"
export * from "./CardOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__